import * as React from 'react'
import { DisplayContent, Plural, Singular } from 'react-content-engine'
import { connect } from 'react-redux'

import { ListItem } from 'components/List'
import IncludeBreakfastSummary from './shared/IncludeBreakfastSummary'

import { FunnelOrder } from '../../data/models/funnelOrder'
import { SiteCountry } from '../../data/models/locale'
import { AppState } from '../../data/state'
import BabyCribSummary from './shared/BabyCribSummary'
import BedAndBreakfastExtrasSummary from './shared/BedAndBreakfastExtrasSummary'
import CO2Summary from './shared/CO2Summary'
import FlexibleRebookingSummary from './shared/FlexibleRebookingSummary'

interface DriveExtrasSummaryProps {
  funnelOrder: FunnelOrder
  country: SiteCountry
}

const DriveExtrasSummary: React.FC<DriveExtrasSummaryProps> = ({
  funnelOrder,
}) => {
  return (
    <>
      {funnelOrder.bedAndBreakfast ||
      funnelOrder.flexibleRebooking ||
      funnelOrder.includeBreakfast ||
      funnelOrder.co2Compensation ||
      funnelOrder.numberOfPets > 0 ||
      funnelOrder.trainTicket > 0 ||
      funnelOrder.trainTicket12 > 0 ||
      (funnelOrder.numberOfBabies > 0 && funnelOrder.babyCrib) ? (
        <>
          <IncludeBreakfastSummary />
          {funnelOrder.trainTicket > 0 ? (
            <ListItem>
              <DisplayContent
                edit={true}
                addNode
                contentKey="travel-with-train-ticket"
                vars={{ pets: funnelOrder.trainTicket.toString() }}
                plural={funnelOrder.trainTicket > 1}
              >
                <Singular>{`Adult train ticket`}</Singular>
                <Plural>{`${funnelOrder.trainTicket} adult train tickets`}</Plural>
              </DisplayContent>
            </ListItem>
          ) : null}
          {funnelOrder.trainTicket12 > 0 ? (
            <ListItem>
              <DisplayContent
                edit={true}
                addNode
                contentKey="travel-with-train-ticket-12"
                vars={{ pets: funnelOrder.trainTicket12.toString() }}
                plural={funnelOrder.trainTicket12 > 1}
              >
                <Singular>{`Child train ticket`}</Singular>
                <Plural>{`${funnelOrder.trainTicket} children train tickets`}</Plural>
              </DisplayContent>
            </ListItem>
          ) : null}
          {funnelOrder.numberOfPets > 0 ? (
            <ListItem>
              <DisplayContent
                edit={true}
                addNode
                contentKey="travel-with-pet-summary"
                vars={{ pets: funnelOrder.numberOfPets.toString() }}
                plural={funnelOrder.numberOfPets > 1}
              >
                <Singular>{`Travelling with ${funnelOrder.numberOfPets} pets`}</Singular>
                <Plural>{`Travelling with ${funnelOrder.numberOfPets} pets`}</Plural>
              </DisplayContent>
            </ListItem>
          ) : null}
          <BabyCribSummary />
          <CO2Summary />
          <FlexibleRebookingSummary />
          <BedAndBreakfastExtrasSummary />
        </>
      ) : (
        <em>
          <DisplayContent contentKey="no-extras-chosen" addNode={false}>
            No extras chosen
          </DisplayContent>
        </em>
      )}
    </>
  )
}

export default connect((state: AppState) => ({
  funnelOrder: state.funnelOrder,
  country: state.locale.country,
}))(DriveExtrasSummary)
